import $ from 'jquery';
import WaveSurfer from 'wavesurfer.js';

/* wavesurfer.js
********************************************/

const padLeadingZeros = function( num, size = 2 ) {
	var s = num + '';

	while ( s.length < size ) {
		s = '0' + s;
	}

	return s;
}

$( window ).on( 'load', function() {
	const $audios = $( '.js-audio' );
	if ( $audios && $audios.length ) {
		$audios.each(function () {
			const $audio = $( this );
	
			if ( $audio.hasClass( 'js-featured-episode' ) ||
				$audio.closest( '.c-card--inactive' ).length > 0) {
				return;
			}
	
			initAudio( $audio );
		});
	}
});

const initAudio = function($audio) {
	if ( ! $audio || ! $audio.length || $audio.hasClass( 'loaded' ) ) {
		return;
	}

	const audioSrc = $audio.attr( 'data-episode-src' );

	if ( audioSrc ) {
		const $playButton = $audio.find( '.js-play' );
		const $forward = $audio.find( '.js-forward' );
		const $backward = $audio.find( '.js-backward' );
		const $mute = $audio.find( '.js-mute-volume' );
		const $playbackRate = $audio.find( '.js-playback-rate' );
		const $seekProgress = $audio.find( '.js-audio-range' );
		const $currentTime = $audio.find( '.js-audio-current-time' );
		const $totalTime = $audio.find( '.js-audio-total-time' );
		const $remainingTime = $audio.find( '.js-audio-remaining-time' );
		const $loader = $audio.find( '.js-audio-loader' );
		const $timeline = $audio.find( '.js-audio-timeline' );

		let duration = 0;

		const wavesurfer = WaveSurfer.create({
			container: $($audio).find( '.waveform' )[0],
			autoCenter: false,
			height: 100,
			barWidth: 4,
			barRadius: 0,
			barGap: 4,
			cursorWidth: 1,
			cursorColor: 'transparent',
			progressColor: 'rgb(0,168,142)',
			waveColor: 'rgba(0,0,0,.15)',
			mediaControls: true,
			skipLength: 15
		});

		wavesurfer.load( audioSrc );

		wavesurfer.on('ready', function () {
			$audio.addClass( 'loaded' );
			$loader.addClass( 'u-hidden' );
			$timeline.removeClass( 'u-hidden' );

			$playButton.attr('disabled', false);
			$forward.attr('disabled', false);
			$backward.attr('disabled', false);
			$mute.attr('disabled', false);
			$playbackRate.attr('disabled', false);

			duration = wavesurfer.getDuration();
			const minutes = padLeadingZeros( Math.floor( duration / 60 ) );
			const seconds = padLeadingZeros( Math.round( duration - minutes * 60 ) );

			$totalTime.html( `${minutes}:${seconds}` );
			$remainingTime.html( `-${minutes}:${seconds}` );

			$playButton.on( 'click', function() {
				wavesurfer.playPause();

				if ( $playButton.hasClass( 'is-playing' ) ) {
					$playButton.removeClass( 'is-playing' );
				} else {
					$playButton.addClass( 'is-playing' );
				}
			} );

			$forward.on( 'click', function() {
				wavesurfer.skipForward( 15 );
			} );

			$backward.on( 'click', function() {
				wavesurfer.skipBackward( 15 );
			} );

			$mute.on( 'click', function() {
				wavesurfer.toggleMute();

				if ( $mute.hasClass( 'is-muted' ) ) {
					$mute.removeClass( 'is-muted' );
				} else {
					$mute.addClass( 'is-muted' );
				}
			} );

			$playbackRate.on( 'click', function() {
				const rate = parseInt( $playbackRate.attr( 'data-rate' ), 10 );

				if ( 0 === rate ) {
					wavesurfer.setPlaybackRate( 1 );
					$playbackRate.find( '.js-rate' ).html( '1x' );
					$playbackRate.attr( 'data-rate', '1' );
				}

				if ( 1 === rate ) {
					wavesurfer.setPlaybackRate( 1.2 );
					$playbackRate.find( '.js-rate' ).html( '1.2x' );
					$playbackRate.attr( 'data-rate', '2' );
				}

				if ( 2 === rate ) {
					wavesurfer.setPlaybackRate( 0.8 );
					$playbackRate.find( '.js-rate' ).html( '0.8x' );
					$playbackRate.attr( 'data-rate', '0.75' );
				}
			} );

			const rangeInputs = document.querySelectorAll('.js-audio-range')

			if ( $seekProgress && $seekProgress.length ) {
				$seekProgress.on( 'change', function() {
					let $target = $( this );

					const val = $target.val();
					const min = $target.attr('min');
					const max = $target.attr('max');

					$target.css( 'background-size', `${(val - min) * 100 / (max - min)}% 100%` );
					wavesurfer.seekTo(val / 100);
				} );

				$seekProgress.on( 'click', function(e) {
					const $target = $( this );

					const min = $target.attr('min');
					const max = $target.attr('max');

					const offset = Math.round( (e.offsetX / e.target.clientWidth) *  parseInt(max,10) );

					$target.css( 'background-size', `${(offset - min) * 100 / (max - min)}% 100%` );
					$target.val(offset);
					wavesurfer.seekTo(offset / 100);
				} );
			}
		});

		wavesurfer.on( 'audioprocess', function() {
			const currentTime = wavesurfer.getCurrentTime();

			let minutes = padLeadingZeros( Math.floor( currentTime / 60 ) );
			let seconds = padLeadingZeros( Math.round( currentTime - minutes * 60 ) );

			$currentTime.html( `${minutes}:${seconds}` );

			const remainingTime = duration - currentTime;

			minutes = padLeadingZeros( Math.floor( remainingTime / 60 ) );
			seconds = padLeadingZeros( Math.round( remainingTime - minutes * 60 ) );

			$remainingTime.html( `-${minutes}:${seconds}` );

			const val = 100 * currentTime / duration;
			const min = $seekProgress.attr('min');
			const max = $seekProgress.attr('max');

			$seekProgress.val(val);
			$seekProgress.css( 'background-size', `${(val - min) * 100 / (max - min)}% 100%` );
		} );

		wavesurfer.on( 'finish', function() {
			$playButton.removeClass( 'is-playing' );
		} );
	}
};


export default initAudio;